import { CONSTANTS } from '../data.js';

export const calculateExpansionCost = (maxDragons) => {
  const upgrades = (maxDragons - CONSTANTS.INITIAL_MAX_DRAGONS) / CONSTANTS.INVENTORY_EXPANSION_SLOTS_PER_UPGRADE;
  return CONSTANTS.INVENTORY_EXPANSION_COST_BASE * Math.pow(CONSTANTS.INVENTORY_EXPANSION_COST_MULTIPLIER, upgrades);
};

export const canBuyDragon = (dragonName, coins, shopCosts, playerDragons, maxDragons) => {
  if (playerDragons.length >= maxDragons) {
    return { canBuy: false, reason: `You can't have more than ${maxDragons} dragons.` };
  }
  const cost = shopCosts[dragonName];
  if (coins < cost) {
    return { canBuy: false, reason: 'Not enough coins.' };
  }
  return { canBuy: true };
};

export const processDragonPurchase = (dragonName, coins, shopCosts, playerDragons) => {
  const cost = shopCosts[dragonName];
  const newPlayerDragons = [...playerDragons, { 
    id: Date.now() + Math.floor(Math.random() * 10000), 
    name: dragonName, 
    level: 1 
  }];
  const newShopCosts = {
    ...shopCosts,
    [dragonName]: shopCosts[dragonName] + CONSTANTS.DRAGON_PRICE_INCREMENT,
  };
  
  return {
    newCoins: coins - cost,
    newPlayerDragons,
    newShopCosts,
    message: `You bought a ${dragonName} dragon!`
  };
};

export const processDragonSale = (dragonId, playerDragons, coins) => {
  const dragonToSell = playerDragons.find(d => d.id === dragonId);
  if (!dragonToSell) return null;

  const dragonData = CONSTANTS.DRAGONS[dragonToSell.name];
  const sellValue = Math.floor(dragonData.value * CONSTANTS.SELL_PERCENTAGE);

  return {
    newCoins: coins + sellValue,
    newPlayerDragons: playerDragons.filter(d => d.id !== dragonId),
    sellValue,
    dragonName: dragonToSell.name
  };
};
